import script from "./VTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTable.vue?vue&type=script&setup=true&lang=ts"

import "./VTable.vue?vue&type=style&index=0&id=6a267385&scoped=true&lang=css"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a267385"]])

export default __exports__